export enum EventType {
  InstitutionChange = 'InstitutionChange',
  AccessTokenChange = 'AccessTokenChange'
}